import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import { Form, DatePicker, Button, Spin } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { Moment } from 'moment';
import { CallNext, useFlow } from '@@/react-hooks';
import * as apiService from '@/service';
import { useAccountInfo } from '@/store/account';
import { UserRole } from '@/enum';
import { url } from '@/url';
import { ExportReport } from '@/service/interface';

import styles from './report.module.less';

interface FormValues {
  range: [Moment, Moment];
}

export const ReportView: FC = () => {
  const account = useAccountInfo();

  const [{ data: html, loading }, onOk] = useFlow('', function* ({ put, call }, { range }: FormValues) {
    const [start, end] = range;
    const html: CallNext<ExportReport> = yield call(apiService.exportReport, {
      start_date: start.startOf('day').format('YYYY-MM-DD HH:mm:ss'),
      end_date: end.endOf('day').format('YYYY-MM-DD HH:mm:ss'),
    });
    yield put(html);
  });

  if (account.userStatus === UserRole.Annotator) {
    return <Redirect to={url.home()} />;
  }

  return (
    <div className={styles.report}>
      <Form preserve={false} className={styles.form} onFinish={onOk}>
        <Link className={styles.back_link} to={url.home()}>
          <LeftOutlined /> 返回首页
        </Link>
        <Form.Item required rules={[{ required: true, message: '请先选择日期范围' }]} name="range">
          <DatePicker.RangePicker placeholder={['开始日期', '结束日期']} />
        </Form.Item>
        <footer>
          <Button htmlType="submit" type="primary" className={styles.button}>
            生成报告
          </Button>
        </footer>
      </Form>
      <Spin spinning={loading}>
        <div className={styles.content}>
          <div dangerouslySetInnerHTML={{ __html: html }} />
        </div>
      </Spin>
      <div />
    </div>
  );
};
